import { jsx } from "react/jsx-runtime";
import { __css, mergeClasses, useFluent } from "@fluentui/react-components";
const useStyles = __css({"mirrored":{"Bz10aip":"f13rod7r"}});
function DirectionalIcon({
  icon: Icon,
  mirror = true,
  className,
  ...rest
}) {
  const { dir } = useFluent();
  const styles = useStyles();
  const mirrored = mirror && dir === "rtl";
  return /* @__PURE__ */ jsx(
    Icon,
    {
      ...rest,
      className: mergeClasses(mirrored && styles.mirrored, className),
      "data-mirrored": mirrored ? "true" : void 0
    }
  );
}
export {
  DirectionalIcon
};
//# sourceMappingURL=directional-icon.js.map

import "/opt/batiflow/app/packages/ui/dist/components/directional-icon/directional-icon.griffel.css";